{
  "#SUBKUNDEN": {
    "TITLE": "Baustellen",
    "PAGES": {
      "SUBKUNDEN": {
        "HEADER": "Baustellen verwalten",
        "SUBKUNDEN": "Baustellen"
      }
    },
    "DIALOGS": {
      "CREATE": {
        "HEADER": "Baustelle anlegen",
        "NUMBER": "Kostenstelle"
      },
      "EDIT": {
        "HEADER": "Baustelle bearbeiten"
      }
    },
    "MENU": {
      "LIST": "Liste",
      "CREATE": "Erstellen",
      "EDIT": "Bearbeiten"
    },
    "MESSAGES": {
      "SAVE_SUCCESS": "Die Baustelle wurde gespeichert"
    }
  },
  "#GESAMTABFRAGE": {
    "ADD_ONS": {
      "CHANGE_BAUSTELLE": {
        "TITLE": "Baustelle ändern",
        "LABEL": "Kst/Baustelle",
        "CURRENT": "Aktuell",
        "SUBMIT": "Speichern"
      }
    }
  },
  "#HAFTRUECKLASS": {
    "TITLE": "Offene Haftrücklässe",
    "PAGES": {
      "QUERY": {
        "HEADER": "Suchen",
        "RESET": "Zurücksetzen",
        "SUBMIT": "Suche starten"
      },
      "LIST": {
        "HEADER": "Suchergebnisse",
        "QUERY": "Angewenderte Filter:",
        "FILTER": "Suchen / Filtern",
        "RESULTS": "Offene Haftrücklässe",
        "NO_DATA": "Es konnten keine Daten gefunden werden"
      }
    },
    "DIALOGS": {
      "EDIT_DUE_DATE": {
        "HEADER": "Fälligkeitsdatum ändern",
        "CURRENT": "Aktuelles Fälligkeitsdatum",
        "NEW": "Neues Fälligkeitsdatum",
        "SUBMIT": "Speichern"
      }
    },
    "MENU": {
      "QUERY": "Abfrage",
      "RESULT": "Ergebnisse",
      "LOCK": "Sperren",
      "UNLOCK": "Entsperren",
      "CHANGE_DUE": "Fälligkeit ändern"
    },
    "MESSAGES": {
      "SUCCESS": {
        "CHANGED": "Der offene Haftrücklass wurde geändert",
        "LOCKED": "Der offene Haftrücklass wurde gesperrt",
        "UNLOCKED": "Der offene Haftrücklass wurde entsperrt"
      },
      "QUESTIONS": {
        "LOCK": "Möchten Sie den offenen Haftrücklass wirklich sperren?",
        "UNLOCK": "Möchten Sie den offenen Haftrücklass wirklich entsperren?"
      }
    }
  },
  "#FREIGABE": {
    "WIDGET": {
      "ABAU_FREIGABE": {
        "AUFSTELLUNG": "Aufstellung",
        "RECHNUNGSSUMME": "Rechnungssumme",
        "ABSTRICH": " - Abstrich",
        "ABSTRICH_PLACEHOLDE": "Betrag",
        "RECHNUNGSSUMME_NACH_ABSTRICH": "Rechnungssumme nach Abstrich",
        "RECHNUNGSSUMME_NACH_ABZUG": "Rechnungssumme netto",
        "USTSATZ": "+ {{ustsatz.prozentsatz}}% MwSt",
        "RECHNUNGSSUMME_BRUTTO": "Rechnungssumme brutto",
        "LEISTUNGSSUMME_BRUTTO": "Leistungssumme brutto",
        "ZWISCHENSUMME_BRUTTO": "Zwischensumme brutto",
        "ZWISCHENSUMME": "Zwischensumme",
        "TEILRECHNUNGEN": " - bisherige Teilrechnungen",
        "TEILRECHNUNGEN_SKONTIERT": " - bisherige Teilrechnungen (skontiert)",
        "ANZUWEISENDER_BETRAG": "Anzuweisender Betrag",
        "RECHNUNGSBETRAG": "Rechnungsbetrag",
        "HR": " - HR",
        "DR": " - DR",
        "ZUWACHS": "Zuwachs",
        "ZAHLUNGSBETRAG": "Zahlungsbetrag",
        "SKONTO": " - Skonto",
        "BEGRUENDUNG": "Bemerkung",
        "SUBMIT": "Speichern & Weiter",
        "SAVE": "Speichern",
        "FAELLIGKEIT": "Fälligkeit",
        "FAELLIGKEIT_LIEFERANT": "Überweisungsdatum Lieferant",
        "FAELLIGKEIT_MITGLIED": "Einzugsdatum Mitglied"
      }
    }
  }
}
